module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单审核状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderStatusName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "代理商"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentName) + " " + _vm._s(_vm.Form.AreaName) + " " + _vm._s(_vm.Form.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderTime))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单人"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "要求发货时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "margin-left": "25px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.AddForm.RequireSendDate),
      callback: function($$v) {
        _vm.$set(_vm.AddForm, "RequireSendDate", $$v)
      },
      expression: "AddForm.RequireSendDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货情况"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "margin-left": "25px"
    },
    model: {
      value: (_vm.SendGood),
      callback: function($$v) {
        _vm.SendGood = $$v
      },
      expression: "SendGood"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "全部发货",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "部分发货",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.myProduct != ''),
      expression: "myProduct!=''"
    }],
    staticClass: "edit-form",
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.myProduct,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductNum",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "UnSendNum",
      "label": "未通知数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SendNum",
      "label": "通知数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "width": "100px",
            "margin-top": "5px"
          },
          attrs: {
            "size": "small",
            "min": 0,
            "max": scope.row.UnSendNum,
            "disabled": _vm.Isabled
          },
          model: {
            value: (scope.row.SendNum),
            callback: function($$v) {
              _vm.$set(scope.row, "SendNum", $$v)
            },
            expression: "scope.row.SendNum"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.myGifts != ''),
      expression: "myGifts!=''"
    }],
    staticClass: "edit-form",
    attrs: {
      "label": "赠品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.myGifts,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProductNum",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "UnSendNum",
      "label": "未通知数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SendNum",
      "label": "通知数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "width": "100px",
            "margin-top": "5px"
          },
          attrs: {
            "size": "small",
            "min": 0,
            "max": scope.row.UnSendNum,
            "disabled": _vm.Isabled
          },
          model: {
            value: (scope.row.SendNum),
            callback: function($$v) {
              _vm.$set(scope.row, "SendNum", $$v)
            },
            expression: "scope.row.SendNum"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentConsignee))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": _vm.AddressShow
    }
  }, [_vm._v("修改")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.Consignee) + "--" + _vm._s(_vm.Form.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "寄送方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendModeName))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.getCommonList(8)
      }
    }
  }, [_vm._v("修改")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "支付方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PayModeName))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.getCommonList(9)
      }
    }
  }, [_vm._v("修改")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderRemark))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "25px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createSure
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "寄送方式",
      "size": "tiny"
    },
    model: {
      value: (_vm.dialog.send),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "send", $$v)
      },
      expression: "dialog.send"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.SendMode),
      callback: function($$v) {
        _vm.SendMode = $$v
      },
      expression: "SendMode"
    }
  }, _vm._l((_vm.SendList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  })), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.SurePaySend(1)
      }
    }
  }, [_vm._v("确认修改")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "支付方式",
      "size": "tiny"
    },
    model: {
      value: (_vm.dialog.pay),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "pay", $$v)
      },
      expression: "dialog.pay"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.PayMode),
      callback: function($$v) {
        _vm.PayMode = $$v
      },
      expression: "PayMode"
    }
  }, _vm._l((_vm.PayList), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.ParmName))])
  })), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.SurePaySend(2)
      }
    }
  }, [_vm._v("确认修改")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择收货地址"
    },
    model: {
      value: (_vm.dialog.addAddressVisible),
      callback: function($$v) {
        _vm.$set(_vm.dialog, "addAddressVisible", $$v)
      },
      expression: "dialog.addAddressVisible"
    }
  }, [_c('el-row', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.AddressList,
      "border": ""
    },
    on: {
      "row-click": _vm.myRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Address",
      "label": "收货地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Consignee",
      "label": "收货人",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ConsigneeTel",
      "label": "联系方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsDefault",
      "label": "是否默认"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.IsDefault) ? _c('el-button', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("当前默认")]) : _c('el-button', {
          attrs: {
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.setDefaultAddress(scope.$index, scope.row)
            }
          }
        }, [_vm._v("设为默认\n                        ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "选择省"
    },
    on: {
      "change": _vm.Province
    },
    model: {
      value: (_vm.Address.ConsigneeProvince),
      callback: function($$v) {
        _vm.$set(_vm.Address, "ConsigneeProvince", $$v)
      },
      expression: "Address.ConsigneeProvince"
    }
  }, _vm._l((_vm.ProvinceList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "选择市"
    },
    on: {
      "change": _vm.City
    },
    model: {
      value: (_vm.Address.ConsigneeCity),
      callback: function($$v) {
        _vm.$set(_vm.Address, "ConsigneeCity", $$v)
      },
      expression: "Address.ConsigneeCity"
    }
  }, _vm._l((_vm.CityList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "选择区"
    },
    model: {
      value: (_vm.Address.ConsigneeArea),
      callback: function($$v) {
        _vm.$set(_vm.Address, "ConsigneeArea", $$v)
      },
      expression: "Address.ConsigneeArea"
    }
  }, _vm._l((_vm.AreaList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.Address.ConsigneeAdress),
      callback: function($$v) {
        _vm.$set(_vm.Address, "ConsigneeAdress", $$v)
      },
      expression: "Address.ConsigneeAdress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入联系人"
    },
    model: {
      value: (_vm.Address.Consignee),
      callback: function($$v) {
        _vm.$set(_vm.Address, "Consignee", $$v)
      },
      expression: "Address.Consignee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入联系方式"
    },
    model: {
      value: (_vm.Address.ConsigneeTel),
      callback: function($$v) {
        _vm.$set(_vm.Address, "ConsigneeTel", $$v)
      },
      expression: "Address.ConsigneeTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设为默认地址"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.Address.IsDefault),
      callback: function($$v) {
        _vm.$set(_vm.Address, "IsDefault", $$v)
      },
      expression: "Address.IsDefault"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("确认添加")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b013945c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/CreateSkipOrder.vue
// module id = 1554
// module chunks = 1